/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import useStore from './store'

export default function D4(props) {
  const { nodes, materials } = useGLTF('./D4.glb')
  const matcapTexture = useStore((state) => state.matcapTexture);
  return (
    <group {...props} dispose={null}>
      <mesh
        name="D4"
        castShadow
        receiveShadow
        geometry={nodes.D4.geometry}
      >
        <meshMatcapMaterial matcap={matcapTexture} />
      </mesh>
      <mesh
        name="D4001"
        castShadow
        receiveShadow
        geometry={nodes.D4001.geometry}
        material={nodes.D4001.material}
      />
    </group>
  )
}

useGLTF.preload('./D4.glb')